export default __webpack_public_path__ + "static/media/icon-notifications-warning.8d3d5813.svg";